import { Inventory as PackageIcon } from "@mui/icons-material";
import { AppBar, Button, Stack, Toolbar } from "@mui/material";
import type { UserInfo } from "firebase/auth";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import type { UserContext } from "../auth/auth";
import { featureFlags } from "../featureFlags/featureFlags";
import { CustomerAppBar } from "./CustomerAppBar";
import NewUiButton from "./NewUiButton";
import { RefreshAllButton } from "./RefreshAllButton";
import { useSiteMap } from "./Sitemap";
import User from "./User";

interface NavigationProps {
  readonly context: UserContext;
}

const Navigation: FC<NavigationProps> = ({ context }) => {
  const navigate = useNavigate();
  const sitemap = useSiteMap(context);
  return (
    <Stack direction="row">
      {sitemap.map(({ label, icon, link }) => (
        <Button key={label} color="inherit" startIcon={icon} onClick={() => navigate(link)}>
          {label}
        </Button>
      ))}
      <NewUiButton />
    </Stack>
  );
};

const PublicNavigation = () => {
  const navigate = useNavigate();
  return (
    <Stack direction="row">
      <Button color="inherit" startIcon={<PackageIcon />} onClick={() => navigate("/public/packages")}>
        Pakiety
      </Button>
    </Stack>
  );
};

interface Props {
  readonly userInfo: UserInfo | null;
  readonly context: UserContext | null;
}

export const MainAppBar: FC<Props> = ({ userInfo, context }) => {
  const isCustomer = context?.role === "CUSTOMER";
  const isUI2Enabled = featureFlags.enabled("appbar2.0");
  if (isCustomer && isUI2Enabled) {
    return <CustomerAppBar context={context} userInfo={userInfo} />;
  }
  return (
    <AppBar>
      <Toolbar
        style={{
          justifyContent: "space-between",
        }}
      >
        {!context ? <PublicNavigation /> : <Navigation context={context} />}
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
          }}
        >
          {userInfo && <RefreshAllButton />}
          <User user={userInfo} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default MainAppBar;
